import script from "./Prescriptions.vue?vue&type=script&setup=true&lang=js"
export * from "./Prescriptions.vue?vue&type=script&setup=true&lang=js"

import "./Prescriptions.vue?vue&type=style&index=0&id=05b14eb2&lang=css"

const __exports__ = script;

export default __exports__